import { render, staticRenderFns } from "./Jewel03.vue?vue&type=template&id=4c63653c&scoped=true&"
import script from "./Jewel03.vue?vue&type=script&lang=js&"
export * from "./Jewel03.vue?vue&type=script&lang=js&"
import style0 from "./Jewel03.vue?vue&type=style&index=0&id=4c63653c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63653c",
  null
  
)

export default component.exports